export default __webpack_public_path__ + "static/media/Spinner.9597f0b3.gif";